export function track(
  event: string,
  data: Record<string, unknown | Record<string, unknown>>,
) {
  if (window.mixpanel) {
    window.mixpanel.track(event, data)
  }
}
